import {windowReady} from "./helpers.js";
import {KTUtil} from "../theme/js/global/components/base/util.js";
import {KTApp} from "../theme/js/global/components/base/app.js";
import {KTLayout} from "../theme/js/global/layout/layout.js";
import {KTOffcanvasPanel} from "../theme/js/global/layout/offcanvas-panel.js";
import {KTQuickSearch} from "../theme/js/global/layout/quick-search.js";

windowReady(() => {
    KTApp.init({
        "colors": {
            "state": {
                "brand": "#3699ff",
                "metal": "#c4c5d6",
                "light": "#ffffff",
                "accent": "#00c5dc",
                "primary": "#5867dd",
                "success": "#34bfa3",
                "info": "#36a3f7",
                "warning": "#ffb822",
                "danger": "#fd3995",
                "focus": "#9816f4"
            },
            "base": {
                "label": [
                    "#c5cbe3",
                    "#a1a8c3",
                    "#3d4465",
                    "#3e4466"
                ],
                "shape": [
                    "#f0f3ff",
                    "#d9dffa",
                    "#afb4d4",
                    "#646c9a"
                ]
            }
        }
    });

    KTLayout.init();
    KTOffcanvasPanel.init();

    if (KTUtil.get('kt_quick_search_dropdown')) {
        KTQuickSearch().init(KTUtil.get('kt_quick_search_dropdown'));
    }

    if (KTUtil.get('kt_quick_search_inline')) {
        KTQuickSearch().init(KTUtil.get('kt_quick_search_inline'));
    }

    if (KTUtil.get('kt_quick_search_offcanvas')) {
        KTQuickSearch().init(KTUtil.get('kt_quick_search_offcanvas'));
    }
});

document.addEventListener("click", function (e) {
    const body = KTUtil.get('body');
    let query = body.querySelectorAll('.kt-menu__nav .kt-menu__item.kt-menu__item--submenu.kt-menu__item--hover:not(.kt-menu__item--tabs)[data-ktmenu-submenu-toggle="click"]')

    if (query) {
        let i = 0;
        const len = query.length;

        for (; i < len; i++) {
            const element = query[i].closest('.kt-menu__nav').parentNode;

            if (element) {
                const the = KTUtil.data(element).get('menu');

                if (!the) {
                    break;
                }

                if (!the || the.getSubmenuMode() !== 'dropdown') {
                    break;
                }

                if (e.target !== element && element.contains(e.target) === false) {
                    the.hideDropdowns();
                }
            }
        }
    }
});

export {}
